

















































import TabsInfoMixin from '../../devices/TabsInfoMixin';
import Component from 'vue-class-component';
import { Mixins } from 'vue-mixin-decorator';
import { Prop } from 'vue-property-decorator';
import { Global } from '@/store';

@Component({
    components: {}
})

class OverviewTab extends Mixins<TabsInfoMixin>(TabsInfoMixin) {
    @Global.State('lang') lang;

    @Prop() metaDevice;

    get model() {
        return this.metaDevice && this.metaDevice.model ? this.metaDevice.model : 'N/A';
    }

    get manufacturer() {
        return this.metaDevice && this.metaDevice.manufacturer ? this.metaDevice.manufacturer : 'N/A';
    }

    get interface_data() {
        return this.metaDevice && this.metaDevice.interface ? this.metaDevice.interface : 'N/A';
    }
}

export default OverviewTab;
